import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'
import useBreadcrumbs from 'use-react-router-breadcrumbs'


export default function BreadScrumbs(props){
       const routes = [
        { path: '/', breadcrumb: 'Home' },
        { path: '/inventory', breadcrumb: 'Inventory' },
        { path: '/inventory/:id', breadcrumb: 'NFT Detail' },
        { path: '/marketplace', breadcrumb: 'Marketplace' },
        { path: '/marketplace/:id', breadcrumb: 'NFT Detail' },
        { path: '/refferal', breadcrumb: 'Refferal Program' },

      ];
    const breadcrumbs = useBreadcrumbs(routes);
    const location = useLocation()
  
      return (
        <div className="h-[24.2rem] w-full bg-third flex flex-col justify-center items-center">
        <h3 className="text-white mb-[1.2rem] uppercase">{props.name}</h3>
        <div>
        <nav className=''>
          {breadcrumbs.map(({ match, breadcrumb }, index) => (
                <Link to={match.pathname} key={index} className={`${match.pathname === location.pathname ? 'text-primary' : 'text-[#888B8E]' } pr-[0.8rem] border-r-2 mr-[0.8rem] border-r-[#888B8E] last:border-none`} >
              {breadcrumb}
            </Link>
          ))}
        </nav>
        </div>
       </div>
       
      );
}